// Vita Nova — interacciones propias (vanilla, sin dependencias externas)

function vnInitReveals() {
  var els = document.querySelectorAll('.vn-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vn-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vn-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function vnInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-vn-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-vn-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-vn-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        principal.src = full;
        thumbs.forEach(function (t) { t.classList.remove('vn-pp__miniatura--activa'); });
        thumb.classList.add('vn-pp__miniatura--activa');
      });
    });
  });
}

function vnInitSelectorVariantes() {
  var forms = document.querySelectorAll('[data-vn-form]');
  forms.forEach(function (form) {
    var script = form.querySelector('[data-vn-variantes]');
    if (!script) return;

    var variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var pastillas = form.querySelectorAll('[data-vn-opcion]');
    var inputId = form.querySelector('[data-vn-variant-id]');
    var seccion = form.closest('.vn-pp');
    var precioEl = seccion ? seccion.querySelector('[data-vn-precio]') : form.querySelector('[data-vn-precio]');
    var precioTachadoEl = seccion ? seccion.querySelector('[data-vn-precio-tachado]') : form.querySelector('[data-vn-precio-tachado]');
    var boton = form.querySelector('[data-vn-boton-comprar]');
    var botonTexto = form.querySelector('[data-vn-boton-texto]');
    var imagenPrincipal = seccion ? seccion.querySelector('[data-vn-galeria-principal]') : null;
    if (!pastillas.length || !inputId) return;

    var seleccion = {};
    pastillas.forEach(function (p) {
      if (p.classList.contains('vn-pp__pastilla--activa')) {
        seleccion[p.getAttribute('data-vn-opcion')] = p.getAttribute('data-vn-valor');
      }
    });

    function formatoMoneda(centavos) {
      return (centavos / 100).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
    }

    function actualizar() {
      var variante = variantes.find(function (v) {
        return Object.keys(seleccion).every(function (pos) {
          return v['option' + pos] === seleccion[pos];
        });
      });
      if (!variante) return;

      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioTachadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachadoEl.textContent = formatoMoneda(variante.compare_at_price);
          precioTachadoEl.hidden = false;
        } else {
          precioTachadoEl.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        if (botonTexto) {
          botonTexto.textContent = variante.available
            ? botonTexto.getAttribute('data-texto-disponible') || botonTexto.textContent
            : botonTexto.getAttribute('data-texto-agotado') || botonTexto.textContent;
        }
      }
      if (imagenPrincipal && variante.featured_image && variante.featured_image.src) {
        imagenPrincipal.src = variante.featured_image.src;
        if (variante.featured_image.alt) imagenPrincipal.alt = variante.featured_image.alt;
      }
    }

    pastillas.forEach(function (pastilla) {
      pastilla.addEventListener('click', function () {
        var opcion = pastilla.getAttribute('data-vn-opcion');
        var valor = pastilla.getAttribute('data-vn-valor');
        seleccion[opcion] = valor;
        form.querySelectorAll('[data-vn-opcion="' + opcion + '"]').forEach(function (p) {
          p.classList.remove('vn-pp__pastilla--activa');
        });
        pastilla.classList.add('vn-pp__pastilla--activa');
        actualizar();
      });
    });
  });
}

function vnInitZoomProducto() {
  var galerias = document.querySelectorAll('[data-vn-galeria]');
  galerias.forEach(function (galeria) {
    var abrirBtn = galeria.querySelector('[data-vn-zoom-abrir]');
    var seccion = galeria.closest('.vn-pp');
    var overlay = seccion ? seccion.querySelector('[data-vn-zoom]') : null;
    if (!abrirBtn || !overlay) return;

    var imgOverlay = overlay.querySelector('[data-vn-zoom-img]');
    var cerrarBtn = overlay.querySelector('[data-vn-zoom-cerrar]');

    function abrir() {
      var principal = galeria.querySelector('[data-vn-galeria-principal]');
      if (!principal) return;
      var src = principal.src.replace(/width=\d+/, 'width=2000');
      imgOverlay.src = src;
      imgOverlay.alt = principal.alt || '';
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.setAttribute('data-vn-zoom-abierto', '');
      });
      document.body.style.overflow = 'hidden';
    }

    function cerrar() {
      overlay.removeAttribute('data-vn-zoom-abierto');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        overlay.hidden = true;
      }, 250);
    }

    abrirBtn.addEventListener('click', abrir);
    cerrarBtn.addEventListener('click', cerrar);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) cerrar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) cerrar();
    });
  });
}

function vnInitAnuncios() {
  var contenedores = document.querySelectorAll('[data-vn-anuncios]');
  contenedores.forEach(function (contenedor) {
    var mensajes = contenedor.querySelectorAll('.vn-anuncios__mensaje');
    if (mensajes.length < 2) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var velocidad = parseInt(contenedor.getAttribute('data-vn-velocidad'), 10) || 4000;
    var indice = 0;
    setInterval(function () {
      mensajes[indice].classList.remove('vn-anuncios__mensaje--activo');
      indice = (indice + 1) % mensajes.length;
      mensajes[indice].classList.add('vn-anuncios__mensaje--activo');
    }, velocidad);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  vnInitReveals();
  vnInitGaleriaProducto();
  vnInitSelectorVariantes();
  vnInitZoomProducto();
  vnInitAnuncios();
});
